import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';

export default function useUser() {
  const auth = getAuth();
  return useAuthState(auth);
}
